import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from './confirmation.component';
import { AccommodationComponent } from './accommodation/accommodation.component';
import { ConfirmationRoutingModule } from './confirmation.routing';
import { ConferenceComponent } from './conference/conference.component';
import { AccommodationGuard } from './services/accommodation.guard';
import { ConferenceGuard } from './services/conference.guard';

import { NgxKjuaModule } from 'ngx-kjua';

@NgModule({
  declarations: [
    ConfirmationComponent,
    ConferenceComponent,
    AccommodationComponent
  ],
  imports: [CommonModule, ConfirmationRoutingModule, NgxKjuaModule],
  providers: [AccommodationGuard, ConferenceGuard]
})
export class ConfirmationModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/confirmation.module.ts